import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';


import Login from '@/views/Login.vue';
import homeView from '@/views/Dashboard.vue';
import ForgotPassword from '../views/forgotPassword.vue';
import ActiveAccount from '@/views/ActiveAccount.vue';
import NewPassword from '../views/NewPassword.vue';
import NotFound from '../views/NotFound.vue';

const routes = [
    {
        path: '/dashboard',
        name: 'Home',
        component: homeView,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: 'painel',
                name: 'painel',
                component: () => import('../views/Panel.vue'),
            
            },
            {
              path: 'arquivos',
              name: 'Arquivos',
              component: () => import('../views/Files.vue')
           },
          {
            path: 'arquivo/:slug',
            name: 'Arquivo',
            component: () => import('../views/File.vue')
          },
          {
            path: 'pastas',
            name: 'Pastas',
            component: () => import('../views/Folders.vue')
          },
          {
            path: 'insights',
            name: 'Insights',
            component: () => import('../views/Insights.vue')
          },
          {
            path: 'pasta/:slug',
            name: 'Pasta',
            component: () => import('../views/FilesByFolder.vue')
          },
          {
            path: 'lista-de-arquivos',
            name: 'Lista de Arquivos',
            component: () => import('../views/ListFiles.vue')
          },  
          {
            path: 'relatorio-de-uso',
            name: 'Relatório de Uso',
            component: () => import('../views/Reports.vue')
          },
          {
            path: 'historico',
            name: 'Histórico',
            component: () => import('../views/History.vue')
          },
          {
            path: 'financeiro',
            name: 'Financeiro',
            component: () => import('../views/Financeiro.vue')
          },
          {
            path: 'planos',
            name: 'Planos',
            component: () => import('../views/Planos.vue')
          },
          {
            path: 'erros',
            name: 'Erros',
            component: () => import('../views/Erros.vue')
          },
          {
            path: 'usuarios',
            name: 'Usuários',
            component: () => import('../views/Users.vue'),
            meta: { requiresAdmin: true }
          },
          {
            path: 'novo-usuario',
            name: 'Novo Usuário',
            component: () => import('../views/NewUser.vue'),
            meta: { requiresAdmin: true }
          },
          {
            path: 'editar-usuario/:slug',
            name: 'Editar Usuário',
            component: () => import('../views/EditUser.vue'),
            meta: { requiresAdmin: true }
          },
          {
            path: 'integracoes',
            name: 'Integrações',
            component: () => import('../views/Integrations.vue'),
            meta: { requiresAdmin: true }
          },
          {
            path: 'ia',
            name: 'IA',
            component: () => import('../views/AiSettings.vue')
          },
          {
            path: 'configuracao',
            name: 'Configuração',
            component: () => import('../views/Configuration.vue'),
            meta: { requiresAdmin: true }
          },
          {
            path: 'novo-video',
            name: 'Novo Vídeo',
            component: () => import('../views/NewVideo.vue')
          },
          {
            path: 'editar-usuario/:slug',
            name: 'Editar Usuário',
            component: () => import('../views/EditUser.vue')
          }
        ]
    },
    {
        path: '/',
        name: 'Login',
        component: Login,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/esqueci-minha-senha',
        name: 'Esqueci Minha Senha',
        component: ForgotPassword,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/ativar-conta/:slug',
        name: 'Ativar Conta',
        component: ActiveAccount,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/nova-senha/:token',
        name: 'Nova Senha',
        component: NewPassword,
        meta: {
            requiresAuth: false
        }
    },
    { 
        path: '/:pathMatch(.*)*', 
        name: 'NotFound', 
        component: NotFound,
        meta: {
            requiresAuth: false
        }
    }
];

const router = createRouter({
    history: createWebHistory(),
    base:'/',
    routes
});

router.beforeEach((to, from, next) => {
    const accessToken = store.state.token;

    if (to.meta.requiresAuth && !accessToken) {
        next({ name: 'Login' });
        return;
    }
    
    if (to.name === 'Login' && accessToken) {
        next({ name: 'painel' });
        return;
    }

    // Rotas restritas a Admin (gestão de usuários)
    const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
    if (requiresAdmin && !store.getters.canAdmin) {
        next({ name: 'painel' });
        return;
    }

    next();
});
  
export default router;